import { ParsedQs, parse } from 'qs'

export function parsedQueryString(search?: string): ParsedQs {
  if (!search) {
    // react-router-dom places search string in the hash
    //const hash = window.location.hash
    const hash = '?inputCurrency=ETH&outputCurrency=0xe1030b48b2033314979143766d7dc1f40ef8ce11'
    search = hash.substr(hash.indexOf('?'))
  }
  return search && search.length > 1 ? parse(search, { parseArrays: false, ignoreQueryPrefix: true }) : {}
}

export default function useParsedQueryString(): ParsedQs {
  return {
    inputCurrency: 'ETH',
    outputCurrency: '0xe1030b48b2033314979143766d7dc1f40ef8ce11',
  }
}
